import { Subject } from 'rxjs';

export class CustomSubjectMethod  {
     // TODO : remove this too ?
    name: string;
     // TODO : remove
    method: any;
    subject: Subject<any>;
}
